import { render } from "./WorldCup.vue?vue&type=template&id=0718a659&scoped=true"
import script from "./WorldCup.vue?vue&type=script&lang=js"
export * from "./WorldCup.vue?vue&type=script&lang=js"

import "./WorldCup.vue?vue&type=style&index=0&id=0718a659&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0718a659"]])

export default __exports__